import { useState } from "react";
import { Check, Copy, Crown } from "lucide-react";

interface UserLevelCardProps {
  level: string;
  title: string;
  message?: string;
  announcement?: string;
}

export default function InfoCard({
  level,
  title,
  message,
  announcement,
}: UserLevelCardProps) {
  const [copied, setCopied] = useState(false);

  const copyText = async () => {
    if (!message) return;
    await navigator.clipboard.writeText(message);
    setCopied(true);

    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  return (
    <div className="bg-zinc-950 overflow-hidden rounded-3xl border border-zinc-800 bg-black">
      {/* Background Decoration */}
      {/* <div className="absolute" /> */}

      <div className="relative p-8">
        {/* Top */}
        <div className="flex flex-col gap-6 md:flex-row md:items-center">
          {/* Badge */}
          <div className="flex h-20 w-20 items-center justify-center rounded-full bg-gradient-to-br from-yellow-400 to-orange-500 shadow-lg">
            <Crown size={38} className="text-white" />
          </div>

          {/* Level */}
          <div>
            <p className="text-sm uppercase tracking-widest text-zinc-400">
              User Level
            </p>

            <h2 className="mt-1 text-4xl font-bold text-white first-letter:uppercase">
              {level}
            </h2>
          </div>
        </div>

        {/* Information */}
        <div className="mt-10">
          {message ? (
            <>
              <h3 className="mb-3 text-lg font-semibold text-white">{title}</h3>
              <div className="flex items-center gap-3 rounded-2xl border border-zinc-800 bg-zinc-900 px-4 py-3">
                <div className="flex-1 overflow-hidden">
                  <p className="truncate font-mono text-sm text-zinc-200 md:text-base">
                    {message}
                  </p>
                </div>

                <button
                  onClick={copyText}
                  className="rounded-xl bg-zinc-800 p-3 transition hover:bg-zinc-700"
                >
                  {copied ? (
                    <Check className="h-5 w-5 text-green-400" />
                  ) : (
                    <Copy className="h-5 w-5 text-zinc-300" />
                  )}
                </button>
              </div>
            </>
          ) : (
            <div className="text-white">
              <p>No Announcement</p>
            </div>
          )}

          {announcement && (
            <div
              className="mt-3 text-sm text-zinc-400"
              dangerouslySetInnerHTML={{ __html: announcement }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
